import adjustmentsForDocumentUpdated from '../actions/adjustmentsForDocumentUpdated';
import factsForDocumentUpdated from '../actions/factsForDocumentUpdated';
import headerRowIngested from '../actions/headerRowIngested';
import processingBegan from '../actions/processingBegan';
import rowIngested from '../actions/rowIngested';
import { timePeriodMetadataIngested } from '../actions/timePeriodMetadataIngested';
import { accumulateAdjustmentsFromDataRows } from '../utilities/accumulateAdjustmentsFromDataRows';
import { accumulateFactsFromDataRows } from '../utilities/accumulateFactsFromDataRows';
import { ROW_TYPE_ADJUSTMENT, ROW_TYPE_FACT } from '../utilities/constants';
import { createMetadataFromRaw } from '../utilities/structured-data-utilities';

export const transformIngestedDataByDocumentCode = async (
  documentCode,
  documentJson,
  configJson,
  dispatch
) => {
  dispatch(processingBegan());

  const documentRows = documentJson.values;
  const headerRow = documentRows[configJson.rawDataHeaderRowIndex];
  const dataRows = documentRows.slice(configJson.rawDataHeaderRowIndex + 1);

  dispatch(headerRowIngested(documentCode, headerRow, configJson));

  if (configJson.metadata) {
    const metadata = createMetadataFromRaw(
      configJson.metadata,
      configJson.summableColumnStartIndex,
      documentRows,
      configJson.rawDataHeaderRowIndex
    );

    dispatch(timePeriodMetadataIngested(documentCode, metadata));
  }

  dataRows.forEach((row) => {
    const rowIngestedAction = rowIngested(
      documentCode,
      headerRow,
      row,
      configJson
    );

    dispatch(rowIngestedAction);
  });

  if (configJson.rowType === ROW_TYPE_ADJUSTMENT) {
    const adjustmentsForDocument = accumulateAdjustmentsFromDataRows(
      headerRow,
      dataRows,
      configJson,
      documentCode
    );

    dispatch(
      adjustmentsForDocumentUpdated(documentCode, adjustmentsForDocument)
    );
  }

  if (configJson.rowType === ROW_TYPE_FACT) {
    const factsForDocument = accumulateFactsFromDataRows(
      headerRow,
      dataRows,
      configJson,
      documentCode
    );

    dispatch(factsForDocumentUpdated(documentCode, factsForDocument));
  }
};
